<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()
  const toggle = () => dispatch('toggle', { name: name })

  export let name = 'A checkbox'
  export let checked = false
</script>

<p
  class="label"
  class:active={checked}
  on:click={() => (checked = !checked)}
  on:click={toggle}>
  {name}
</p>

<style lang="scss">
  @import '../responsive.scss';

  .label {
    font-family: 'Arteria-Regular';
    font-size: 4rem;
    color: var(--dark);
    cursor: pointer;
    &::before {
      content: 'O ';
      font-feature-settings: 'ss11' 0, 'ornm' 1;
      color: var(--light);
    }
    &:hover {
      color: var(--light);
    }
    &.active::before {
      font-feature-settings: 'ss11' 1, 'ornm' 1;
    }

    @include for-tablet {
      font-size: 3rem;
    }

    @include for-phone {
      font-size: 2.5rem;
    }
  }
</style>
